/**
 * The largest page a find returns. The generated `find_<atom>` functions clamp
 * `page_size` to 1..`MAX_FIND_PAGE_SIZE`; a find without `pagination` gets the
 * default page of 10 rows (see `FIND_CALL_PARAMETERS`).
 *
 * Shared by the backend paging helpers (`@atoms/atom-module`) and by frontend
 * code that wants "every row": it asks for one page of this size.
 */
export const MAX_FIND_PAGE_SIZE = 1000;

/**
 * The page size of a find without `pagination`. It is the default of
 * `page_size` in `FIND_CALL_PARAMETERS`, the value the Prisma persistor binds
 * and the page size of `MemoryPersistenceProvider`.
 *
 * The generated find procedures repeat it as a literal in their body
 * (`COALESCE(page_size, 10)` in atom-codegen's `FindProcedure.generator.ts`).
 * Change both together.
 */
export const DEFAULT_FIND_PAGE_SIZE = 10;
